/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const n=Symbol("GroundInstance");function o(o){return null!=o&&"object"==typeof o&&n in o}export{n as GroundSymbol,o as isGround};
